import window from '../injectChromeObject'
import type { ExtensionStorageQuotaState } from './getExtensionStorageQuotaState'
import {
  ExtensionStorageQuotaError,
  getExtensionStorageQuotaState
} from './getExtensionStorageQuotaState'

export function getStorage<T extends string>(
  ...keys: T[]
): Promise<{ [key in T]?: any }> {
  try {
    return new Promise<{ [key in T]?: any }>(resolve => {
      window.chrome.storage.local.get(keys, items =>
        resolve(items as { [key in T]?: any })
      )
    })
  } catch {
    return Promise.resolve({})
  }
}

export async function setStorage(
  data: object
): Promise<
  ExtensionStorageQuotaState | ExtensionStorageQuotaError | undefined
> {
  try {
    const quotaState = await getExtensionStorageQuotaState(
      ...Object.entries(data)[0]
    )

    await window.chrome.storage.local.set(data)

    return quotaState
  } catch (error) {
    if (error instanceof ExtensionStorageQuotaError) {
      return error
    }
    return
  }
}

export function removeFromStorage(...keys: string[]): Promise<void> {
  try {
    return window.chrome.storage.local.remove(keys)
  } catch {
    return Promise.resolve()
  }
}
